// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2QqLc","label":"Labeled_label__2qt-3","divider":"Labeled_divider__28BBW"};